export default "__VITE_PUBLIC_ASSET__76ebc751__"